import { useRoute } from 'shared/library/routes/route';
import { Platform, View } from 'react-native';
import { Props, Post, Paginator, Tag } from 'shared/@types';
import { apiRoute } from 'shared/library/api-route';
import { FaqCard } from 'shared/components/faq-card';
import { Text } from 'shared/components/text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { H1, H2 } from 'shared/components/title';
import { PageBuilder } from 'shared/library/page-builder';

interface ShowFaqTagScreenProps extends Props {
  tag: Tag;
  posts: Paginator<Post>;
}

const ShowFaqTagScreen = ({ tag, posts }: ShowFaqTagScreenProps) => {
  const { t } = useTranslation('screens');
  const route = useRoute();

  return (
    <>
      <View className={'p-3 md:p-6 md:py-12'}>
        <View className={`mx-auto w-full max-w-screen-md`}>
          {Platform.OS === 'web' ? (
            <>
              <H1
                title={t('help.title')}
                subtitle={t('help.description')}
                marginTop={false}
                center={true}
              />

              <H2
                title={tag.name}
                subtitle={tag.description}
                linkTitle={t('common:view_all')}
                linkHref={route('help.index')}
              />
            </>
          ) : (
            <H1
              title={tag.name}
              subtitle={tag.description}
              marginTop={false}
              hideTitleWhenNativeHeader={true}
            />
          )}

          <View className={'border-brand-brown-dark/15 rounded-lg border bg-white px-3'}>
            {posts.data.map((post) => (
              <FaqCard key={post.slug.en} post={post} />
            ))}

            <Text className={'text-brand-brown-dark/70 py-6 text-center text-sm'}>
              {t('help.cant_find_question')}
            </Text>
          </View>
        </View>
      </View>
    </>
  );
};

ShowFaqTagScreen.pageBuilder = new PageBuilder<
  ShowFaqTagScreenProps,
  { tag: string; page: string }
>()
  .request(({ req, params }) =>
    req<{ tag: Tag; posts: Paginator<Post> }>(apiRoute('tags.show', { tag: params.tag }), {
      page: params.page,
      per_page: 50,
    }),
  )
  .deriveRouteParams((props) => ({
    tag: props.tag.slug,
  }));

export { ShowFaqTagScreen };
export type { ShowFaqTagScreenProps };
